import {cdnImage} from '@/util/cdnImage';
import {MUIButton, MUIContainer} from '@/components/MUI-Components';
import {HIRE_PROMPT_ENGINEERS} from '@/util/metaData/hire';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';
import React from 'react';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        dataScopeButtonData,
        dataScopeCheckPoint,
        dataScopeSubPoints,
        hirePromptBannerPoint,
        hirePromptChooseBody,
        hirePromptChooseContent,
        hirePromptExpertiseData,
        hirePromptFAQ,
        hirePromptOutcomes,
        hirePromptPricing,
        hirePromptProcessData,
        hirePromptTechStack,
        mediaGuardButtonData,
        mediaGuardCheckPoint,
        mediaGuardSubPoints,
        zendaButtonData,
        zendaCheckPoint,
        zendaSubPoints
    } = await import('@/util/contents/hire-prompt-engineering');

    const {remoteHireBannerBottom} = await import('@/util/contents/remote-developer-data');

    return {
        props: {
            dataScopeButtonData,
            dataScopeCheckPoint,
            dataScopeSubPoints,
            hirePromptBannerPoint,
            hirePromptChooseBody,
            hirePromptChooseContent,
            hirePromptExpertiseData,
            hirePromptFAQ,
            hirePromptOutcomes,
            hirePromptPricing,
            hirePromptProcessData,
            hirePromptTechStack,
            mediaGuardButtonData,
            mediaGuardCheckPoint,
            mediaGuardSubPoints,
            zendaButtonData,
            zendaCheckPoint,
            zendaSubPoints,
            remoteHireBannerBottom
        }
    };
};

const Banner = dynamic(() => import('@/components/Ui-components/Banner'));
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
const TabTechnology = dynamic(() => import('@/components/Ui-components/TabTechnology'));
const LatestCTA = dynamic(() => import('@/components/Ui-components/LatestCta'));
import DoneIcon from '@mui/icons-material/Done';
import {CDN_URL, SITE_URL} from '@/constants/urls';
import {colors} from '@/styles/tokens';
const projectSuccess = cdnImage('Hire-Prompt-engineer/Hire-Prompt-Engineering-Coders.webp');
const Pricing = dynamic(() => import('@/components/Ui-components/pricing'));
const OurMakeChoice = dynamic(() => import('@/components/Ui-components/OurMakeChoice'));
const LetsDiscuss = dynamic(() => import('@/components/Ui-components/Lets-discuss'));
const Questions = dynamic(() => import('@/components/Ui-components/questions'));
const HireProcess = dynamic(() => import('@/components/Ui-components/HireProcess'));
const IndustryLeaders = dynamic(import('@/components/Ui-components/IndustryLeaders'));
const DynamicScreens = dynamic(() => import('@/components/Ui-components/Dynamic-screens'));
const zenda = cdnImage('Hire-Prompt-engineer/Zenda-Solutions.webp');
const dataScope = cdnImage('Hire-Prompt-engineer/DataScope-Insights.webp');
const mediaGuard = cdnImage('Hire-Prompt-engineer/MediaGuard-Systems.webp');

const HireEngineer = (props: any) => {
    const {
        openForm,
        dataScopeButtonData,
        dataScopeCheckPoint,
        dataScopeSubPoints,
        hirePromptBannerPoint,
        hirePromptChooseBody,
        hirePromptChooseContent,
        hirePromptExpertiseData,
        hirePromptFAQ,
        hirePromptOutcomes,
        hirePromptPricing,
        hirePromptProcessData,
        hirePromptTechStack,
        mediaGuardButtonData,
        mediaGuardCheckPoint,
        mediaGuardSubPoints,
        zendaButtonData,
        zendaCheckPoint,
        zendaSubPoints,
        remoteHireBannerBottom
    } = props;

    return (
        <Box>
            <PageHead meta={HIRE_PROMPT_ENGINEERS} url="/hire-prompt-engineers" />
            <Banner
                priority={true}
                handleClickOpen={openForm}
                heading="Hire Prompt Engineers "
                subheading="Accelerate AI innovation with our expert AI prompt engineers. Skilled in optimizing GPT-4, Claude, and DALL-E, our team designs precise prompts to enhance NLP, image generation, and workflows. Whether you're optimizing existing systems or building new AI solutions, we deliver efficiency and scalability aligned with your goals."
                button="Onboard Expert Prompt Engineers "
                image={cdnImage('Hire-Prompt-engineer/Hire-Prompt-Engineers.webp')}
                bannerClass=""
                // bannerBackground="hire-prompt-banner-background"
                alt="Hire Prompt Engineers"
                DataPoints={hirePromptBannerPoint}
            />
            <Box className="sub-banner-wrapper sub-banner-bottom-wrapper">
                <MUIContainer>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="white-label-bottom-container">
                        <Grid item md={2} lg={1.7} sm="auto" xs={12}>
                            <Typography className="banner-bottom-heading">Our Strategic Alliances</Typography>
                        </Grid>
                        {remoteHireBannerBottom?.map((data: any, index: number) => (
                            <Grid item sm="auto" xs={6} className="sub-banner-images" key={index + 1}>
                                <Box className="images-banner-bottom">
                                    <DisplayImage src={data.src} alt={data.alt} />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="top-space bottom-spacing mobile-top-padding mobile-bottom-padding">
                <MUIContainer>
                    <TabTechnology
                        heading="Hire AI Prompt Engineers with Advanced Tech Expertise"
                        subheading="Debut Infotech offers specialized prompt engineering services to optimize <a target='_blank' href='/blog/a-comprehensive-guide-to-understanding-and-using-ai-models'>AI models</a> for exceptional performance. Our certified prompt engineers possess in-depth knowledge and hands-on experience, ensuring efficient and scalable AI solutions tailored to your business needs. Explore the technologies our experts leverage to transform AI capabilities into actionable insights."
                        technology={hirePromptTechStack}
                    />
                </MUIContainer>
            </Grid>

            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <LatestCTA
                    heading="Need Expert Prompt Engineers for Your AI Projects?"
                    subheading="We design prompt models that deliver accuracy, efficiency, and seamless user experiences. From chatbots to voice assistants, let our skilled engineers help you achieve your project goals with the latest AI tools."
                    buttonText="Book a Free Consultation"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="bottom-spacing top-space helper_section_parent mobile-top-padding">
                <MUIContainer>
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                            <Box className="spectrum-header-wrapper solutions trend-dominate-text-wrapper" pb={2}>
                                <Typography className="spectrum-heading color-black " component="h2" pb={2}>
                                    Hire Prompt Engineering Coders for Tailored AI Solutions
                                </Typography>
                                <Typography className="spectrum-sub-heading color-black" component="p">
                                    Transform your AI capabilities with our expert prompt engineering services, designed to create
                                    optimized, contextually aware, and efficient solutions. Whether it’s building chatbots or enhancing
                                    conversational AI, our dedicated engineers deliver scalable and unbiased AI models tailored to your
                                    specific business needs.
                                </Typography>
                            </Box>
                            <Box>
                                {hirePromptOutcomes?.map((item: any, index: number) => (
                                    <Box className="done-icon-wrapper" key={index + 1}>
                                        <DoneIcon sx={{color: colors.text.orangeAccessible}} />
                                        <Box>
                                            <Typography className="done-subheading color-black">{item.subheading}</Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <Box className="hire-prompt-tailored-solution text-center">
                                <DisplayImage src={projectSuccess} alt="Hire Prompt Engineering" />
                            </Box>
                        </Grid>
                    </Grid>
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="bottom-spacing mobile-bottom-padding">
                <Container maxWidth="lg">
                    <Pricing
                        heading="Our Flexible Pricing Plans for Hiring Prompt Engineers"
                        subheading="Let our skilled prompt engineers optimize your AI models for maximum efficiency. Our pricing plans are built with your needs in mind, providing flexibility and scalability for every project type."
                        pricingData={hirePromptPricing}
                        className="remote-pricing-developer-card price-dot-net-card hire-pricing"
                        onClick={openForm}
                    />
                    <Box mt={2} className="prompt-pricing-button">
                        <MUIButton onClick={openForm} label="Share Your Project Brief" className="helper-card-button" />
                    </Box>
                </Container>
            </Grid>
            <Grid item xs={12}>
                <HireProcess heading="Our Streamlined Process for Hiring Prompt Engineers" content={hirePromptProcessData} />
            </Grid>

            <Grid item xs={12} className="dynmaic-white-label-wrapper top-space bottom-margin mobile-top-padding mobile-bottom-margin">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            See How Our Prompt Engineers Delivered Exceptional Results
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Typography className="spectrum-sub-heading color-black text-align-left" component="p">
                            Maximize the efficiency of your AI systems with our expert prompt engineers. From building customized NLP
                            solutions to deploying scalable AI models, our engineers have delivered transformative results for businesses
                            across industries. Explore how we’ve helped organizations achieve their goals with cutting-edge prompt
                            engineering strategies.
                        </Typography>
                    </Box>
                    <DynamicScreens
                        imageSrc={zenda}
                        subHeading="Zenda Solutions"
                        heading="Revolutionizing Customer Support with Conversational AI"
                        subPoints={zendaSubPoints}
                        reverseOrder={true}
                        alt="Zenda Solutions"
                        checkItems={zendaCheckPoint}
                        buttonData={zendaButtonData}
                        openForm={openForm}
                        buttonLabel="Request a Quote"
                        buttonClass="nft-button"
                    />
                    <DynamicScreens
                        imageSrc={dataScope}
                        subHeading="DataScope Insights "
                        heading="Building Real-Time Data Insights for Decision-Making"
                        subPoints={dataScopeSubPoints}
                        reverseOrder={false}
                        alt="DataScope Insights "
                        checkItems={dataScopeCheckPoint}
                        buttonData={dataScopeButtonData}
                        openForm={openForm}
                        buttonLabel="Request a Quote"
                        buttonClass="helper-card-button"
                    />

                    <DynamicScreens
                        imageSrc={mediaGuard}
                        heading="Streamlining Content Moderation with AI Automation"
                        subHeading="MediaGuard Systems"
                        subPoints={mediaGuardSubPoints}
                        reverseOrder={true}
                        alt="MediaGuard Systems"
                        checkItems={mediaGuardCheckPoint}
                        buttonData={mediaGuardButtonData}
                        openForm={openForm}
                        buttonLabel="Request a Quote"
                        buttonClass="nft-button"
                    />
                </MUIContainer>
            </Grid>
            <Box>
                <LatestCTA
                    heading="Have specific project requirements?"
                    subheading="Let our expert prompt engineers create solutions tailored to your business requirements."
                    buttonText="Get a Quote"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12}>
                <Box className="renowed-client-wrapper top-space bottom-spacing mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <IndustryLeaders
                            heading="Diverse Industries Our Prompt Engineers Serve"
                            subheading="With expertise in prompt engineering services, our skilled engineers design AI solutions that drive growth, efficiency, and innovation across various industries."
                            data={hirePromptExpertiseData}
                            className="industry-leader-content-wrapper industry-leader-content-animation"
                            classNm="industry-leader-content-side-space"
                        />
                    </MUIContainer>
                </Box>
            </Grid>
            <OurMakeChoice
                heading="Why Choose Us"
                subheading="to Hire Prompt Engineers?"
                body={hirePromptChooseBody}
                contentData={hirePromptChooseContent}
            />
            <Grid item xs={12} className="bottom-spacing">
                <LetsDiscuss
                    heading="Still Struggling to Find the Right Prompt Engineering Talent?"
                    subheading="Let us help you optimize your AI models and bring your vision to life with precision, scalability, and cutting-edge solutions aligned with your business goals."
                    btnLabel="Define Your Project Scope"
                    className="white-label-sprill"
                    openForm={() => {
                        globalThis.open('/contact-us', '_blank');
                    }}
                />
            </Grid>
            <Grid item xs={12} className="question-parent top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={hirePromptFAQ} subpart={true} />
                </MUIContainer>
            </Grid>
            <script
                type="application/ld+json"
                id="ai-deployment-service"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'What is Prompt Engineering?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Prompt engineering involves designing instructions and examples that guide Large Language Models (LLMs) like GPT-4 to perform specific tasks. By providing precise prompts, this technique ensures accurate and contextually relevant outputs tailored to a wide range of applications, including text generation, sentiment analysis, and conversational AI systems.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How to Hire a Prompt Engineer?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'To hire a prompt engineer, focus on technical expertise and experience with LLMs. Look for candidates skilled in Python, JavaScript, and tools like OpenAI APIs or LangChain. At Debut Infotech, we simplify the process with our vetted pool of prompt engineering experts. We ensure our engineers are aligned with your business needs and can seamlessly integrate into your team.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How Do You Ensure Prompt Engineers Stay Updated on the Latest Technologies?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'At Debut Infotech, we invest in continuous learning. Our engineers regularly attend training, earn certifications, and participate in industry events to stay updated on advancements in prompt engineering. Access to resources like research papers, webinars, and tools ensures they are equipped with cutting-edge knowledge.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How Long Does It Take to Hire a Prompt Engineer?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The hiring process can take between 2–5 days, depending on project complexity and specific skill requirements. Debut Infotech offers a streamlined hiring process to connect you with top-tier talent swiftly, ensuring no project delays.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How Much Does It Cost to Hire a Prompt Engineer?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The cost depends on the engagement model and expertise level. Hourly rates start from $25, while full-time hires cost approximately $3,500/month.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What Tools Are Commonly Used in Prompt Engineering?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Tools like OpenAI APIs, LangChain, PyTorch, and TensorFlow are essential. Engineers also use cloud platforms like AWS and GCP for deployment.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What Is the Role of a Prompt Engineer in AI Development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'A prompt engineer designs and fine-tunes prompts to guide AI models, ensuring accurate, context-aware outputs for tasks like content creation, sentiment analysis, and automation.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How Do Prompt Engineers Improve AI Model Accuracy?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'By refining prompts, leveraging prefix-tuning, and evaluating model outputs, prompt engineers optimize performance and reduce biases in LLMs.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How Does Debut Infotech Ensure Security During the Consulting Process?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'We prioritize security by implementing strict data protection policies, encrypted communication channels, and secure access controls. Adherence to GDPR and other industry standards ensures your sensitive information remains secure throughout the engagement.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Do You Provide Ongoing Support and Maintenance After Completing a Project?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes, as a prompt engineering agency, Debut Infotech offers comprehensive post-project support, including maintenance, updates, and troubleshooting. Our team ensures your AI systems run smoothly and adapt to changing requirements.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can Your Prompt Engineering Consultants Work With Our In-House Team?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Absolutely. Our consultants collaborate seamlessly with your in-house team, providing technical expertise and strategic insights to enhance your AI initiatives. We ensure effective communication and alignment with your objectives.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can You Develop Custom Solutions for Unique Prompt Engineering Challenges?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes, Debut Infotech specializes in designing custom solutions for specific prompt engineering challenges. Whether it’s optimizing existing models or building from scratch, we tailor every aspect to meet your objectives.'
                                }
                            }
                        ]
                    })
                }}
            />
            <script
                id="hire-prompt-engineers"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org/',
                        '@type': 'Product',
                        name: 'Hire Prompt Engineers',
                        image: `${CDN_URL}?url=%2Fimages%2FHire-Prompt-engineer%2FHire-Prompt-Engineers.webp&w=750&q=75`,
                        description:
                            'Hire expert prompt engineers to design, refine, and optimize AI prompts and large-language-model implementations. Improve model accuracy, enhance conversational workflows, and streamline AI systems for tasks like NLP, automation, sentiment analysis, and multilingual interactions.',
                        brand: {
                            '@type': 'Brand',
                            name: 'Debut Infotech Pvt. Ltd.'
                        },
                        offers: {
                            '@type': 'AggregateOffer',
                            url: `${SITE_URL}/hire-prompt-engineers`,
                            priceCurrency: 'USD',
                            lowPrice: '5000',
                            highPrice: '50000',
                            offerCount: '10'
                        },
                        aggregateRating: {
                            '@type': 'AggregateRating',
                            ratingValue: '4.8',
                            bestRating: '5',
                            worstRating: '2',
                            ratingCount: '499'
                        }
                    })
                }}
            />
        </Box>
    );
};

export default HireEngineer;
HireEngineer.Layout = 'Main';
